module.exports = __webpack_public_path__ + "static/media/settings-login.6b331bd0.png";